import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { WahldividendePageBase } from '@zero/bezugsrecht/feature-wahldividende/base';
import { UserMessagesComponent } from '@zero/shared/ui-web-components';

@Component({
  selector: 'wahldividende-page-web',
  templateUrl: './wahldividende-page-web.component.html',
  imports: [RouterOutlet, UserMessagesComponent],
})
export class WahldividendePageWebComponent extends WahldividendePageBase {}
